import { type PropsWithChildren, useEffect, useState } from 'react'

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Grow from '@mui/material/Grow'

import { Link } from '../../router/components/Link'

export { DomainCard }

const delay = 300

interface Props {
  title: string
  to: string
  index: number
}

const DomainCard = ({
  title,
  to,
  children,
  index,
}: PropsWithChildren<Props>) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShow(true)
    }, delay * index)
  }, [index])

  return (
    <Grow
      in={show}
      style={{ transformOrigin: 'center' }}
      timeout={{ enter: 1000 }}
    >
      <Card
        component={Link}
        to={to}
        sx={{
          textDecoration: 'none',
          textAlign: 'center',
          width: '280px',
        }}
      >
        <CardHeader
          title={title}
          sx={{
            '& .MuiCardHeader-title': {
              margin: 0,
              padding: 2,
              color: '#1a4d99',
              fontFamily: 'Aller',
              fontSize: '24px',
              fontWeight: 200,
              marginLeft: '8px',
              // padding: '24px',
              width: '100%',
            },
          }}
        />
        <CardContent>{children}</CardContent>
      </Card>
    </Grow>
  )
}
